const element = document.getElementById("sound-button");

let isEnabled = ! element.classList.contains('icons__icon--crossed');


const enableSound = () => {
    element.classList.remove('icons__icon--crossed');
    isEnabled = singleton.enabled = true;
    singleton.dispatchEvent('unmute');
};

const disableSound = () => {
    element.classList.add('icons__icon--crossed');
    isEnabled = singleton.enabled = false;
    singleton.dispatchEvent('mute');
};

const toogleSound = () => {
    if (isEnabled) {
        disableSound();
    } else {
        enableSound();
    }
};

let clickHandle = event => {
    event.preventDefault();
    toogleSound();
};

element.addEventListener('click', clickHandle);

const singleton = {
    enabled: isEnabled
};
createjs.EventDispatcher.initialize(singleton);
module.exports.soundOnOffControl = singleton;





// WEBPACK FOOTER //
// ./js/sound.js